export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'CPF';
export const NAME = 'CPF';
